<div class="product-slider" *ngIf="featuredCategory">
    <div class="product-slider-header">
        <div class="box-heading"><span i18n="@@Bestsellers">Bestsellers {{featuredCategory.categoryName}}</span></div>
        <div id="{{sliderId}}"  class="carousel slide hidden-xs" data-ride="carousel" > <!--data-interval="10000"-->
            <div class="carousel-inner" role="listbox">
                <pdp-product-list [content]="featuredCategory.products" [isFeatured]="true"></pdp-product-list>
            </div>
        </div>
        <!-- <div class="nav">
            <a href="#{{sliderId}}" role="button" class="prev"  data-slide="prev"><!--&lt;--><!--</a>
            <a href="#{{sliderId}}" role="button" class="next"  data-slide="next"><!--&gt;--><!--</a>
        </div> -->
    </div> 
</div>